import { api } from '../../../services/api';

const FILTERS_URL = '/filters/';

export const getFilters = () => api.get(FILTERS_URL);
